var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "delivery-area" }, [
    _c(
      "div",
      { staticClass: "map-toolbar" },
      [
        _c(
          "el-button",
          {
            attrs: {
              type: "primary",
              size: "small",
              icon: "el-icon-refresh-left",
            },
            on: { click: _vm.restoreInitialArea },
          },
          [_vm._v("\n      撤销\n    ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "danger", size: "small", icon: "el-icon-delete" },
            on: { click: _vm.clearAllDrawings },
          },
          [_vm._v("\n      清空\n    ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {
      ref: "mapContainer",
      staticClass: "tencent-map",
      staticStyle: { width: "100%", height: "500px", "margin-top": "10px" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }